import { render } from "./CategoryListPage.vue?vue&type=template&id=7dce0f06"
import script from "./CategoryListPage.vue?vue&type=script&lang=js"
export * from "./CategoryListPage.vue?vue&type=script&lang=js"
script.render = render

export default script